/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Lista_Tarjeta_Documentacion_Informacion from "./SubComponentes/Lista_Tarjeta_Documentacion_Informacion";
import {theme} from "../../../Tema";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Documentacion_Informacion = () => {

    const {masSM} = useResponsive();

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}
            sx={{backgroundColor: '#EFEFEF'}}>
            <Grid2 container size={12}
                   sx={{maxWidth: '1400px', px: 3, pt: 10, pb: 5}} justifyContent={'center'}>


                <Grid2 container size={{xs: 12, sm: 12, md: 11}}>

                    <Grid2 container size={{xs: 2, sm: 12, md: 2}}
                           sx={{pr: 20, pt: 6, borderBottom: `6px solid ${theme.palette.primary.main}`}}>

                    </Grid2>


                    <Grid2 container size={12} sx={{my: 10}}>
                        <Lista_Tarjeta_Documentacion_Informacion/>
                    </Grid2>

                </Grid2>



            </Grid2>

        </Grid2>
    )

}
export default Documentacion_Informacion